import { Card, CardBody, CardHeader, CardTitle, Collapse } from "reactstrap";
import { useI18n } from "../../utils/lni18n";
import { ImagePickerService, imageAtom } from "./ImagePickerService";
import { useAtom } from "jotai";
import { currentUserReadOnlyAtom } from "../../services/user/userService";
import LnIcon from "../LnIcon";
import ImageInfoForPart from "./ImageInfoForPart";

const ImageInfo = (props: { imagePickerService: ImagePickerService }) => {

    const imagePickerService = props.imagePickerService;
    const { languageService: t } = useI18n();
    const [state] = useAtom(imageAtom);
    const { selectedImage, currentImage, deleteRequested } = state;
    const [user] = useAtom(currentUserReadOnlyAtom);

    const onDeleteRequest = (state: boolean) => {
        imagePickerService.setDeleteRequested(state);
    }

    const doDelete = () => {
        imagePickerService.deleteCurrentImage();
    }



    if (!currentImage) return null;

    const totalOthersCount = currentImage.Overview.TotalOtherCount;

    return <>

        {selectedImage && user?.Id === selectedImage.User.Id && currentImage && <>

            <button className="ms-auto d-block btn btn-inverse btn-danger" onClick={() => onDeleteRequest(true)} >
                <LnIcon className="icon-medium" name="delete" />
            </button>


            <Collapse isOpen={deleteRequested} >
                <div className="mb-4">
                    {(currentImage.Overview.TotalReferenceCount > 0) && t.getText("image.used.delete.warning")}
                    <br />
                    {t.getText("sure_to_delete")}
                    <div className="mt-3 d-flex justify-content-between">
                        <button className="btn btn-inverse" onClick={() => onDeleteRequest(false)} >{t.getText("cancel")}</button>
                        <button className="btn btn-danger btn-inverse" onClick={() => doDelete()} >{t.getText("image.delete")}</button>
                    </div>
                </div>
            </Collapse>


        </>
        }

        {currentImage.Overview.TotalReferenceCount > 0 ? <>
            <h3 className="mb-3">{t.getText("in.use")}</h3>
            <div >
                {currentImage.Overview.CourseParts.length > 0 && <Card className="mb-5">
                    <CardHeader>
                        <CardTitle> {t.getText("courseparts")} </CardTitle>
                    </CardHeader>
                    <CardBody>

                        {currentImage.Overview.CourseParts.map((c, i) => <ImageInfoForPart key={i} data={c} />
                        )}
                    </CardBody>
                </Card>}

                { totalOthersCount > 0  &&

                    <Card >
                        <CardHeader>
                            <CardTitle> {t.getText("additional")} </CardTitle>
                        </CardHeader>
                        <CardBody>
                            <table className="table table-sm table-borderless">

                                <thead>
                                    <tr>
                                        <th>{t.getText("type")}</th>
                                        <th>{t.getText("amount")}</th>
                                    </tr>
                                </thead>

                                <tbody>


                                    {currentImage.Overview.MailCount > 0 && <tr>
                                        <td>
                                            {t.getText("email")}
                                        </td>
                                        <td>
                                            {currentImage.Overview.MailCount}
                                        </td>
                                    </tr>}

                                    {currentImage.Overview.NotificationCount > 0 && <tr >
                                        <td>
                                            {t.getText("notifications")}
                                        </td>
                                        <td>
                                            {currentImage.Overview.NotificationCount}
                                        </td>

                                    </tr>}

                                    {currentImage.Overview.StudentCommentCount > 0 && <tr>
                                        <td>
                                            {t.getText("student.notes")}
                                        </td>
                                        <td>
                                            {currentImage.Overview.StudentCommentCount}
                                        </td>

                                    </tr>}

                                    {currentImage.Overview.CourseAddonCount > 0 && <tr>
                                        <td>
                                            {t.getText("courseaddons")}
                                        </td>
                                        <td>
                                            {currentImage.Overview.CourseAddonCount}
                                        </td>

                                    </tr>}

                                    {currentImage.Overview.UnitCount > 0 && <tr>
                                        <td>
                                            {t.getText("units")}

                                        </td>
                                        <td>
                                            {currentImage.Overview.UnitCount}
                                        </td>
                                    </tr>}


                                    { ( currentImage.Overview.ClassDiplomaCount > 0 
                                            || currentImage.Overview.CourseDiplomaCount > 0) && <tr>
                                        <td>
                                            {t.getText("diploma")}

                                        </td>
                                        <td>
                                            {currentImage.Overview.ClassDiplomaCount + currentImage.Overview.CourseDiplomaCount}
                                        </td>
                                    </tr>}


                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                }

            </div>
        </> : <h4>{t.getText("image.overview.not.used.anywhere")}</h4>
        }

    </>
}

export default ImageInfo;
